module.exports = __webpack_public_path__ + "static/sessionwire-screen1-2ed25a4562d4ffbee302630dcaadacb3.jpg";